import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Mail, Phone, Building2, Share2 } from "lucide-react";
import { USERS } from "@/constants/testIds";
import { initials } from "@/lib/initials";

export function UserIdentityHeader({ user }) {
  return (
    <div className="flex items-center gap-3">
      <Avatar className="h-12 w-12">
        <AvatarFallback className="bg-orange-100 text-orange-700 font-semibold">
          {initials(user.display_name)}
        </AvatarFallback>
      </Avatar>
      <div>
        <div className="font-semibold text-slate-900">{user.display_name}</div>
        <div className="text-xs text-slate-500">{user.job_title}</div>
      </div>
    </div>
  );
}

const ContactLine = ({ icon: Icon, children }) => (
  <div className="flex items-center gap-2 text-slate-700">
    <Icon className="w-3.5 h-3.5 text-slate-400" strokeWidth={1.75} />{children}
  </div>
);

export function UserContactCard({ user }) {
  return (
    <div className="rounded-md border border-slate-200 p-3 text-xs space-y-1.5">
      <ContactLine icon={Mail}>{user.mail}</ContactLine>
      <ContactLine icon={Phone}>{user.business_phones?.[0] || "—"}</ContactLine>
      <ContactLine icon={Building2}>{user.department || "—"} · {user.office_location || "—"}</ContactLine>
    </div>
  );
}

export function TemplateAssignSelect({ value, onChange, templates, noneValue }) {
  return (
    <div className="space-y-1.5">
      <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Plantilla a asignar</div>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="focus:ring-orange-500" data-testid={USERS.templateSelect}>
          <SelectValue placeholder="Seleccionar plantilla..." />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={noneValue}>Sin plantilla (usar reglas)</SelectItem>
          {templates.map((t) => (
            <SelectItem key={t.id} value={t.id}>{t.name} · {t.category}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}

export function SocialToggleCard({ checked, onChange, disabled }) {
  return (
    <div className="rounded-md border border-slate-200 p-3">
      <div className="flex items-start gap-3">
        <Share2 className="w-4 h-4 text-orange-600 mt-0.5 shrink-0" strokeWidth={1.75} />
        <div className="flex-1 min-w-0">
          <Label htmlFor="social-toggle" className="text-sm font-medium text-slate-900 cursor-pointer">
            Mostrar iconos de redes sociales en esta firma
          </Label>
          <p className="text-xs text-slate-500 mt-0.5">
            Aplica solo a este usuario. Requiere URLs configuradas en Configuración → Identidad.
          </p>
        </div>
        <Switch id="social-toggle" checked={checked} onCheckedChange={onChange} disabled={disabled}
          className="data-[state=checked]:bg-orange-600" data-testid="user-show-social-toggle" />
      </div>
    </div>
  );
}
